import { SASTType } from './config';

export function getSASTSourceType(
  sastType: SASTType | string | undefined,
): string {
  let source_type = 'sast2';
  return source_type;
}
